// extracted by mini-css-extract-plugin
export default {"marketsTableContainer":"styles_marketsTableContainer__mPK4N","tableBottom":"styles_tableBottom__4uqE3","chevronRight":"styles_chevronRight__a-oiN"};